import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { FavoriteToggle } from '~src/favorites/components/favoriteToggle/FavoriteToggle';
import { CardTitle } from '~src/spacesPlatform/components/card/CardTitle';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CardPopoverWidget, ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { Thumbnail } from '~src/spacesPlatform/components/card/Thumbnail';
import { ContentTooltipProps } from '~src/spacesPlatform/components/tooltip/TooltipHelper';

import { PublishedConnectionTooltip } from '../../../publishedConnection/components/tooltips/PublishedConnectionTooltip';

export const PublishedConnectionTableDefaultImageUrl = 'spaces_masthead_table_connection.svg';

export class PublishedConnectionTableCard extends ContentCard {
  public render() {
    const {
      content, hovered, selected, allowDragAndDrop, urls, addContentFavorite, removeContentFavorite
    } = this.props;
    return (
      <div className={CardViewStyles.Card}>
        <Thumbnail
          defaultImageUrl={imgPath(PublishedConnectionTableDefaultImageUrl)}
          thumbnailImageUrl={content.thumbnailUrl}
          hovered={hovered}
          selected={selected}
          navigateUrl={getContentUrlForItem(content, urls)}
          useBase64EncodedImage={true}
          allowDragAndDrop={allowDragAndDrop}
          aria-label={content.name}
        />
        <div className={CardViewStyles.ActionRow}>
          <CardTitle name={content.name} />
          <span>
            <CardPopoverWidget
              content={content}
              onTriggerClick={this.handleShowPopover}
              popoverContent={this.renderPopoverContent()}
              title={Messages.publishedConnectionTableTooltipTitle()}
            />
          </span>
          <span>
            <FavoriteToggle
              isTabbable={true}
              isFavorite={content.favorite}
              onAddFavorite={() => addContentFavorite({ ...content, contentType: 'virtualConnectionTable' })}
              onRemoveFavorite={() => removeContentFavorite({ ...content, contentType: 'virtualConnectionTable' })}
            />
          </span>
          {this.renderActionsMenu()}
        </div>
        <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>
      </div>
    );
  }

  protected getPopoverComponent(): React.ComponentType<ContentTooltipProps> {
    return PublishedConnectionTooltip;
  }
}
